import { Controller } from "@hotwired/stimulus"

// Assinatura com o dedo (touch) ou mouse num <canvas>, sem biblioteca externa.
// No submit do form, grava o PNG (data URL) no hidden input; bloqueia envio
// sem traço no canvas.
export default class extends Controller {
  static targets = ["canvas", "input"]

  connect() {
    this.canvas = this.canvasTarget
    this.ctx = this.canvas.getContext("2d")
    this.drawing = false
    this.dirty = false

    this.resizeCanvas()
    this.ctx.lineWidth = 2
    this.ctx.lineCap = "round"
    this.ctx.strokeStyle = "#111827"

    this.canvas.addEventListener("pointerdown", (e) => this.beginStroke(e))
    this.canvas.addEventListener("pointermove", (e) => this.stroke(e))
    this.canvas.addEventListener("pointerup", () => this.endStroke())
    this.canvas.addEventListener("pointercancel", () => this.endStroke())
  }

  resizeCanvas() {
    this.canvas.width = this.canvas.clientWidth || 600
    this.canvas.height = 200
  }

  position(event) {
    const rect = this.canvas.getBoundingClientRect()
    return {
      x: (event.clientX - rect.left) * (this.canvas.width / rect.width),
      y: (event.clientY - rect.top) * (this.canvas.height / rect.height)
    }
  }

  beginStroke(event) {
    event.preventDefault()
    // Pointer Capture: o traço continua mesmo se o dedo/mouse sair do quadrado
    // (movimento rápido não perde o press — padrão de qualquer signature pad)
    this.canvas.setPointerCapture(event.pointerId)
    this.drawing = true
    this.dirty = true
    const { x, y } = this.position(event)
    this.ctx.beginPath()
    this.ctx.moveTo(x, y)
  }

  stroke(event) {
    if (!this.drawing) return
    event.preventDefault()
    const { x, y } = this.position(event)
    this.ctx.lineTo(x, y)
    this.ctx.stroke()
  }

  endStroke() {
    if (!this.drawing) return
    this.drawing = false
    this.syncInput()
  }

  clear() {
    this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height)
    this.dirty = false
    this.syncInput()
  }

  // O hidden input é atualizado a CADA traço — não dá pra depender da ordem
  // dos handlers no submit (o Turbo pode serializar o form antes do nosso).
  syncInput() {
    if (!this.hasInputTarget) return
    this.inputTarget.value = this.dirty ? this.canvas.toDataURL("image/png") : ""
  }

  submit(event) {
    if (!this.dirty) {
      event.preventDefault()
      alert("Colha a assinatura antes de confirmar.")
      return
    }
    this.syncInput()
  }
}
